export const getIsFullscreen = () => {
  try {
    const element = document.documentElement

    if (
      document.fullscreenElement ||
      element.fullscreenElement ||
      element.webkitIsFullScreen ||
      element.mozFullscreen ||
      element.msFullscreenElement ||
      element.fullscreen ||
      element.webkitFullscreenElement ||
      element.mozFullScreenElement
    ) {
      return true
    }

    return false
  } catch (e) {
    console.log(e)
    return false
  }
}

export const enterFullscreen = () => {
  return new Promise((resolve, reject) => {
    try {
      if (!getIsFullscreen()) {
        const catchError = (error) => {
          reject(error)

          setTimeout(() => {
            alert('Please make sure that your browser can enter fullscreen mode')
          }, 200)
        }

        const element = document.documentElement

        if (element.requestFullscreen) {
          element.requestFullscreen({ navigationUI: 'hide' }).then(resolve).catch(catchError)
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen()?.then(resolve)?.catch(catchError)
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()?.then(resolve)?.catch(catchError)
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen()?.then(resolve)?.catch(catchError)
        } else {
          reject('Not supported')
        }
      } else {
        resolve()
      }
    } catch (error) {
      reject(error)
    }
  })
}

export const exitFullscreen = (callback = () => {}) => {
  try {
    if (getIsFullscreen()) {
      const element = document.documentElement

      if (document.exitFullscreen) {
        document.exitFullscreen().finally(callback)
      } else if (element.exitFullscreen) {
        element.exitFullscreen().finally(callback)
      } else if (element.webkitCancelFullScreen) {
        element.webkitCancelFullScreen()?.finally(callback)
      } else if (element.mozCancelFullScreen) {
        element.mozCancelFullScreen()?.finally(callback)
      } else if (element.msExitFullscreen) {
        element.msExitFullscreen?.finally(callback)
      }
    } else {
      callback()
    }
  } catch (e) {
    console.log(e)
    callback()
  }
}
